export default {
    androidMethod(action, data = {}, callback = "") {
        console.log("androidMethod", action, data, callback)
        let params = {
            "id": "0.8459706990489422",
            action,
            data,
            callback
        }
        params = JSON.stringify(params);
        window.android.postData(params);
    },
    postAFEvent(data) {
        console.log("postAFEvent", data)
        let params = {
            "id": "0.8459706990489422",
            "action": "postAFEvent",
            "callback": "",
            "data": {
                "eventName": data
            },
        }
        params = JSON.stringify(params);
        window.android.postData(params);
    }
}
